import { attemptReadingPwu, attemptReadingUtm } from "@views/layouts/helpers";

export function getProductQRCodeUrl({ productId, utmParam }) {
  const pwu = attemptReadingPwu();
  const utm = attemptReadingUtm();
  const qrcodeBaseUrl = `https://zhenguo.meituan.com/housing/${productId}/`;
  const pwuParam = pwu
    ? `phx_wake_up_type=${encodeURIComponent(pwu.type)}&phx_wake_up_source=${encodeURIComponent(pwu.source)}`
    : utm
    ? `phx_wake_up_type=${encodeURIComponent(utm.utm_medium)}&phx_wake_up_source=${encodeURIComponent(utm.utm_source)}`
    : "";
  return `https://ms1.meituan.net/qrc/s?c=${encodeURIComponent(
    `${qrcodeBaseUrl}?${[utmParam, pwuParam].filter(Boolean).join("&")}`
  )}`;
}
